import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

// Always talk to our own origin — the Emergent ingress routes `/api/*` to
// the backend on ANY domain the app is served from (preview URL, production
// defectr.co.uk, emergent.host, etc). Ignoring REACT_APP_BACKEND_URL here
// prevents cross-origin session-cookie drops, which used to break login on
// Safari and, after certain rebuilds, on Chrome too.
export const API = '/api';

axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
            setUser(res.data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip the /me check.
        // AuthCallback will exchange the session_id and establish the session first.
        if (window.location.hash?.includes('session_id=')) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const logout = async () => {
        try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch (err) { console.warn('Logout request failed', err); }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, loading, logout, refresh: checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
